<template>
  <div class="flex flex-col min-h-screen">
    <div class="container mx-auto px-4 py-8 md:px-6 lg:px-8 pb-40">
      <header class="mb-6">
        <BreadCrumbs :crumbs="crumbs" class="mb-4" />
        <Title :title="service?.name || 'Service'" class="text-3xl font-extrabold text-gray-900" />
      </header>

      <section class="mb-8">
        <div class="bg-white shadow-md rounded-lg border border-gray-200 p-6">
          <p class="text-sm text-gray-700 leading-relaxed">
            {{ service?.description }}
          </p>
        </div>
      </section>

      <div v-if="loading" class="flex justify-center items-center w-full min-h-[240px] bg-white shadow-md rounded-lg border border-gray-200">
        <Loader />
      </div>

      <div v-else-if="error" class="bg-red-50 border border-red-200 rounded-lg p-6">
        <h3 class="font-semibold text-red-800 mb-1">Pricing could not be loaded</h3>
        <p class="text-sm text-red-700 mb-4">{{ error }}</p>
        <button
          class="px-3 py-2 text-sm bg-red-600 text-white rounded hover:bg-red-700"
          @click="reload"
        >
          Try again
        </button>
      </div>

      <slot v-else />
    </div>

    <PriceBar
      :monthlyRecurringCost="monthlyCost"
      :itemCount="itemCount"
      :addservice="true"
      :canAdd="canAdd"
      :summary="true"
      @addservice="$emit('add')"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BreadCrumbs from "@/components/BreadCrumbs.vue";
import Title from "@/components/Title.vue";
import PriceBar from "@/components/PriceBar.vue";
import Loader from "@/components/Loader.vue";
import { findService } from "@/utils/services";

export default {
  name: "ServicePage",
  components: { BreadCrumbs, Title, PriceBar, Loader },
  props: {
    serviceId: { type: String, required: true },
    monthlyCost: { type: Number, default: 0 },
    itemCount: { type: Number, default: 0 },
    canAdd: { type: Boolean, default: false },
  },
  emits: ["add"],
  computed: {
    ...mapGetters({
      loading: "pricing/loading",
      loaded: "pricing/loaded",
      error: "pricing/error",
    }),
    service() {
      return findService(this.serviceId);
    },
    crumbs() {
      return [
        { text: "Home", to: "/" },
        { text: "WX-One Pricing Calculator", to: "/calculator" },
        { text: this.service?.name || "Service" },
      ];
    },
  },
  created() {
    this.$store.dispatch("pricing/fetchCatalog").catch(() => {});
  },
  methods: {
    reload() {
      this.$store.dispatch("pricing/fetchCatalog", { force: true }).catch(() => {});
    },
  },
};
</script>
